export const getImportSummaryTooltipOverrideStyle = ({ palette = {} }) => ({
  '& .import-error-table': {
    '& .import-error-message': {
      marginTop: 18,
    },

    '& .import-error-message + table': {
      marginTop: 15,
      maxHeight: 300,
      overflowX: 'hidden',
      overflowY: 'auto',
      width: 'max-content',
      display: 'block',
    },

    '& .grid-header-text': {
      color: palette.neutralPrimary,
      cursor: 'default',
      textDecoration: 'none',
    },

    '& .grid-row.error': {
      backgroundColor: '#FDE7E9',
    },
  },
});
